"use client";

import { Popover } from "@/components/controls/base-controls";
import DatePicker from '@/components/helpers/date-picker';
import type { FlightValue } from '@/core/types/flight.type';
import { Flight } from '@/core/types/flight.type';

type CalendarPopoverProps = {
    departure_dates: Date[];
    anchorEl: HTMLElement | null;
    open: boolean;
    flight: FlightValue;
    onClose: (value: Date[]) => void;
};

const getTodayWithoutTime = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

const getOneYearFromToday = () => {
  const futureDate = new Date();
  futureDate.setHours(0, 0, 0, 0);
  futureDate.setFullYear(futureDate.getFullYear() + 1); // 👈 Adds exactly 1 year
  return futureDate;
};

const CalendarPopover = (props: CalendarPopoverProps) => {
    const { anchorEl, open, departure_dates, flight, onClose } = props;

    const handleClose = () => {
        onClose(departure_dates);
    };

    const handleSetDate = (value: Date[] | undefined) => {
        onClose(value || []);
    }

    return (
        <Popover 
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
            slotProps={{ paper: { sx: { mt: "0" } } }}
        >
            <DatePicker 
                mode={flight === Flight.ONEWAY ? "single" : "range"}
                selectedDates={departure_dates}
                disabled={[
                    { before: getTodayWithoutTime() },
                    { after: getOneYearFromToday() }
                ]}
                onClose={handleSetDate}
            
            />
            
        </Popover>
    )
}

export default CalendarPopover;
